<div class="container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
  <div class="lang-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <div class="flag-lang-container">
      <img src="../../../../assets/img/sn-flag.svg" alt="" />
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <span class="current-lang">Sénégal</span>
      <span class="bnt-toggle-menu-lang"><mat-icon fxLayoutAlign="start center">keyboard_arrow_down</mat-icon></span>
    </div>
  </div>
  <div class="separator"></div>
  <div class="input-search-container" fxLayoutAlign="start center" fxLayoutGap="12px">
    <label for="search"><mat-icon fxLayoutAlign="start center">search</mat-icon></label>
    <input class="input-desktop" type="text" id="search" name="search"
      [placeholder]="'Titre du poste, mot-clé, entreprise'" />
    <input class="input-tablete" type="text" id="search" name="search" [placeholder]="'Titre du poste, mot-clé...'" />
  </div>
</div>